/** French geometry prompts and classification vocabulary (ADR 0051 part 3). */
export const geometryPrompts = {
    classifyAngle: (measure: number) =>
        `Un angle mesure ${measure}°. Est-il aigu, droit, obtus ou plat ?`,
    missingAngleTriangle: (a: number, b: number) =>
        `Deux angles d'un triangle mesurent ${a}° et ${b}°. Quel est le troisième angle ?`,
    missingAngleLine: (a: number) =>
        `Deux angles sont sur une droite. L'un mesure ${a}°. Quel est l'autre ?`,
    missingAnglePoint: (a: number, b: number) =>
        `Trois angles se rencontrent en un point. Deux mesurent ${a}° et ${b}°. Quel est le troisième ?`,
    complement: (given: number) => `Quel est le complément de ${given}° ?`,
    supplement: (given: number) => `Quel est le supplément de ${given}° ?`,
    classifyTriangle: (a: number, b: number, c: number) =>
        `Un triangle a des côtés de ${a} cm, ${b} cm et ${c} cm. Est-il scalène, isocèle ou équilatéral ?`,
    polygonSidesFromName: (name: string) => `Combien de côtés a un ${name} ?`,
    polygonNameFromSides: (sides: number) => `Comment appelle-t-on un polygone à ${sides} côtés ?`,
};

export const angleClassLabels: Record<'acute' | 'right' | 'obtuse' | 'straight', string> = {
    acute: 'aigu',
    right: 'droit',
    obtuse: 'obtus',
    straight: 'plat',
};

export const triangleClassLabels: Record<'equilateral' | 'isosceles' | 'scalene', string> = {
    equilateral: 'équilatéral',
    isosceles: 'isocèle',
    scalene: 'scalène',
};

export const polygonNames: Record<number, string> = {
    3: 'triangle',
    4: 'quadrilatère',
    5: 'pentagone',
    6: 'hexagone',
    7: 'heptagone',
    8: 'octogone',
    9: 'ennéagone',
    10: 'décagone',
};
